const getters = {
  SKILLS: ({ skills }) => skills || [],
  SKILLS_LOADING: ({ skillsLoading }) => skillsLoading,
  SKILL_ACTION_LOADING: ({ skillActionLoading }) => skillActionLoading,
};

export default getters;